module.exports = __webpack_public_path__ + "img/watch.17cb7b1a.svg";